module.exports = __webpack_public_path__ + "static/media/screen3.65cb5c9d.png";